// extracted by mini-css-extract-plugin
module.exports = {"page":"CompanyDisabled_page_3oOxV","container":"CompanyDisabled_container_2zjK-","box":"CompanyDisabled_box_EbLLv"};